import React, { Component } from 'react';
import { PnkHtmlForm } from '../../../pnk-react/pnk-controls/pnk-html-form';
import PnkImage from '../../../pnk-react/pnk-ctrl/pnk-image'


export default class TourForm extends Component {
    // constructor(props) {
    //     super(props)
    // }

    render() {
        return (
            <div>
                <div class="add-organizer-form-main">
            
                    {/* <div class="form-back-link" onClick={() => this.props.HandleRouting('home')}>
                        <i class="fa fa-arrow-left" aria-hidden="true"></i>
                        <a>Back</a>
        </div>  */}
                    <div className="add-organizer-form-main-div">


                        <div class="container-fluid">
                            <h3>{this.props.mystate.showButtonType}</h3>

                            <PnkHtmlForm id="frmTourEntry" onsubmit={this.props.SaveTourEntryData} submitbtn="btnTourEntry" style={{ marginTop: '20px' }}>
                                <div className="edit-btn-div" style={{ display: this.props.mystate.showEditBtn }}>
                                    <button type="button" variant="light" className="profile-entry-cancel-btn btn" onClick={() => this.props.ShowEditMode()}>Edit</button>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Tour Name</label>
                                            <input type="text" class="form-control form2-control-ausi"
                                                id="txtTourName"
                                                name="txtTourName"
                                                placeholder="Tour Name"
                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.txtTourName}
                                                value={this.props.mystate.txtTourName}
                                                onBlur={this.props.HandleTourInput}
                                                pnkdisplayerrormsg="Invalid Tour Name"

                                            />
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Tour Duration</label>
                                            <input type="text" class="form-control form2-control-ausi" id="txtTourDuration"
                                                name="txtTourDuration"
                                                placeholder="Tour Duration"
                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.txtTourDuration}
                                                value={this.props.mystate.txtTourDuration}
                                                onBlur={this.props.HandleTourInput}
                                                pnkdisplayerrormsg="Invalid Duration"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Tour Theme</label>
                                            <select class="custom-select mr-sm-2 form2-control-ausi"
                                                id="ddlTourTheme"
                                                name="ddlTourTheme"
                                                //placeholder="Event Name"
                                                pnkvalidate="forceselect"
                                                pnkvalue={this.props.editDataObj.ddlTourTheme}
                                                value={this.props.mystate.ddlTourTheme}
                                                pnkdisplayerrormsg="Please select one option"
                                                onChange={this.props.HandleTourInput} >

                                                <option value="">Select One...</option>
                                                <option value="Family Tour">Family Tour</option>
                                                <option value="Friend Tour">Friend Tour</option>
                                                <option value="Group Tour">Group Tour</option>
                                                <option value="Solo Tour">Solo Tour</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>


                                <div class="row">

                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Tour Cost</label>
                                            <input type="text" class="form-control form2-control-ausi" id="txtTourCost"
                                                name="txtTourCost"
                                                placeholder="Tour Cost"
                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.txtTourCost}
                                                value={this.props.mystate.txtTourCost}
                                                onBlur={this.props.HandleTourInput}
                                                pnkdisplayerrormsg="Invalid Cost"
                                            />
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Tour Cities</label>
                                            <input type="text" class="form-control form2-control-ausi" id="txtTourCities"
                                                name="txtTourCities"
                                                placeholder="Tour Cities"
                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.txtTourCities}
                                                value={this.props.mystate.txtTourCities}
                                                onBlur={this.props.HandleTourInput}
                                                pnkdisplayerrormsg="Invalid Cities"
                                            />
                                        </div>
                                    </div>


                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group tour-pdf-file kinship-img-file" id="kinship-img-file">
                                            <label for="exampleFormControlInput1">Upload Tour Details</label>
                                            <PnkImage
                                                class="form-control form2-control-ausi" id="fileTourDetailsPdf"
                                                onChange={this.props.HandleTourInput}
                                                destinationFolder="application/public/images/uploads/kinship/tour"
                                                allowedTypeStr="pdf"
                                                btnPreviewText="Upload Tour Details"
                                               // multiple="true"
                                              //  limitFiles="5"

                                                name="fileTourDetailsPdf"
                                                id="fileTourDetailsPdf"

                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.fileTourDetailsPdf}
                                                value={this.props.mystate.fileTourDetailsPdf}
                                                mode={this.props.mystate.mode}
                                                renderChild={this.props.mystate.renderChild}
                                                previewImageSrc={this.props.editDataObj.fileTourDetailsPdf}
                                                pnkdisplayerrormsg="Invalid Tour File"
                                                itemStyle="height:150px;text-align:center"
                                            />
                                        </div>
                                    </div>


                                </div>
                                <div class="row">
                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Tour Highlights</label>
                                            <textarea class="form-control form2-control-ausi" id="txtTourHighlights"
                                                name="txtTourHighlights" rows="3"
                                                placeholder="Tour Highlights"
                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.txtTourHighlights}
                                                value={this.props.mystate.txtTourHighlights}
                                                onBlur={this.props.HandleTourInput}
                                                pnkdisplayerrormsg="Invalid Tour Highlights"
                                            ></textarea>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Tour Status</label>
                                            <select class="custom-select mr-sm-2 form2-control-ausi"
                                                id="ddlTourStatus"
                                                name="ddlTourStatus"
                                                pnkvalidate="forceselect"
                                                pnkvalue={this.props.editDataObj.ddlTourStatus}
                                                value={this.props.mystate.ddlTourStatus}
                                                onChange={this.props.HandleTourInput} >
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-12 col-sm-6 col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label for="exampleFormControlInput1">Tour Flight</label>
                                            <select class="custom-select mr-sm-2 form2-control-ausi"
                                                id="ddlTourFlight"
                                                name="ddlTourFlight"
                                                pnkvalidate="forceselect"
                                                pnkvalue={this.props.editDataObj.ddlTourFlight}
                                                value={this.props.mystate.ddlTourFlight}
                                                onChange={this.props.HandleTourInput} >
                                                <option value="0">Not Include</option>
                                                <option value="1">Include</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>

                                <div class="col-12 col-sm-12 col-md-12 col-lg-12">
                              
                                    <div class="form-group kinship-img-file multi_image_upload" id="kinship-img-file">
                                        <label for="exampleFormControlInput1">Upload Images</label>
                                      
                                             
                                            <PnkImage
                                                class="form-control form2-control-ausi" id="fileTourImage"
                                                onChange={this.props.HandleTourInput}
                                                destinationFolder="application/public/images/uploads/kinship/tour"
                                                allowedTypeStr="png,jpg,jpeg"
                                                btnPreviewText="Upload Tour Image"
                                                multiple="true"
                                                limitFiles="5"

                                                name="fileTourImage"
                                                id="fileTourImage"

                                                pnkvalidate="forceentry"
                                                pnkvalue={this.props.editDataObj.fileTourImage}
                                                value={this.props.mystate.fileTourImage}
                                                mode={this.props.mystate.mode}
                                                renderChild={this.props.mystate.renderChild}
                                                previewImageSrc={this.props.editDataObj.fileTourImage}
                                                pnkdisplayerrormsg="Invalid Tour Image"
                                                itemStyle="height:150px;text-align:center"
                                            />
                                        

                                           
                                    </div>
                                </div>

                                <button class="btn add-organizer-btn pnkvalidatesubmit" id="btnTourEntry" name="save" onClick={() => this.props.SaveTourEntryData} >{this.props.mystate.showButtonType}</button>

                            </PnkHtmlForm>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}